import { useAuth0 } from "@equipmentshare/auth0-react";
import React from "react";
import {
  Auth0ApplicationConfigurationType,
  getAuth0ApplicationConfiguration,
} from "~/Auth/Config";
import { Button } from "./ButtonV2";

export const useLogout = (): (() => void) => {
  const {
    clientId,
    redirectUri,
  }: Auth0ApplicationConfigurationType = getAuth0ApplicationConfiguration();

  const auth0 = useAuth0();
  const { logout } = auth0;

  return () => logout({ client_id: clientId, returnTo: `${redirectUri}` });
};

export function Logout() {
  const [loading, setLoading] = React.useState(false);
  const logout = useLogout();

  const onLogout = () => {
    setLoading(true);
    logout();
  };

  return (
    <Button type="text" onClick={onLogout} loading={loading}>
      Logout
    </Button>
  );
}
